"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LinkDropDownList = _interopRequireDefault(require("../../forms/LinkDropDownList"));

var _Anchor = _interopRequireDefault(require("../../general/Anchor"));

var _Spacing = _interopRequireDefault(require("../../layout/Spacing"));

var _FormSearchBox = _interopRequireDefault(require("../../forms/FormSearchBox"));

var _underscore = _interopRequireDefault(require("underscore"));

var _PropUtils = require("../../../util/PropUtils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var EnvironmentSelector = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(EnvironmentSelector, _React$Component);

  var _super = _createSuper(EnvironmentSelector);

  function EnvironmentSelector() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, EnvironmentSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      open: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleToggle", function () {
      return _this.setState({
        open: !_this.state.open
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getDDLOption", function (option) {
      return _underscore.default.extend(option, {
        label: option.label,
        value: option.id
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getSelectedOption", function () {
      var _context2;

      var selectedList = (0, _filter.default)(_context2 = _this.props.options).call(_context2, function (option) {
        return option.id === _this.props.environment;
      });

      if (selectedList.length > 0) {
        return _this._getDDLOption(selectedList[0]);
      } else {
        return {};
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getOptions", function () {
      var _context3;

      return (0, _map.default)(_context3 = _this.props.options).call(_context3, _this._getDDLOption);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getIcon", function (option) {
      var iconClassName = (0, _PropUtils.getIconClassName)(option);

      if (iconClassName) {
        return /*#__PURE__*/_react.default.createElement("span", {
          className: "".concat(iconClassName, " environment-selector__icon")
        });
      } else {
        return /*#__PURE__*/_react.default.createElement("span", {
          className: "icon-earth environment-selector__icon"
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleClick", function (selected) {
      return _this.props.onEnvironmentChange(selected.value);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleNewEnvironment", function () {
      _this.props.onNewEnvironment();

      _this._handleToggle();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_renderLink", (0, _PropUtils.makeRenderWithClassName)("environment-selector__link"));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var selectedOption = _this._getSelectedOption();

      var bottomPanel = _this.props.onNewEnvironment ? /*#__PURE__*/_react.default.createElement(_Anchor.default, {
        onClick: _this._handleNewEnvironment,
        "data-id": "new-environment"
      }, _this.props.newEnvironmentLabel) : null;
      var _this$props = _this.props,
          search = _this$props.search,
          onSearch = _this$props.onSearch;
      var searchPanel = search !== undefined || onSearch ? /*#__PURE__*/_react.default.createElement(_Spacing.default, {
        spacing: _Spacing.default.sizes.SM
      }, /*#__PURE__*/_react.default.createElement(_FormSearchBox.default, {
        noSpacing: true,
        onValueChange: _this.props.onSearch,
        value: _this.props.search,
        width: _FormSearchBox.default.inputWidths.MAX
      })) : null;
      return /*#__PURE__*/_react.default.createElement(_LinkDropDownList.default, {
        closeOnClick: true,
        "data-id": _this.props["data-id"],
        label: /*#__PURE__*/_react.default.createElement("span", null, _this._getIcon(selectedOption), selectedOption.label),
        onClick: _this._handleClick,
        onToggle: _this._handleToggle,
        open: _this.state.open,
        options: _this._getOptions(),
        selectedOption: selectedOption,
        className: "environment-selector left",
        bottomPanel: bottomPanel,
        renderLink: _this._renderLink,
        topPanel: searchPanel
      });
    });
    return _this;
  }

  return EnvironmentSelector;
}(_react.default.Component);

(0, _defineProperty2.default)(EnvironmentSelector, "propTypes", {
  "data-id": _propTypes.default.string,
  onEnvironmentChange: _propTypes.default.func,
  onNewEnvironment: _propTypes.default.func,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    label: _propTypes.default.string,
    value: _propTypes.default.string
  })),
  environment: _propTypes.default.string,
  newEnvironmentLabel: _propTypes.default.string
});
(0, _defineProperty2.default)(EnvironmentSelector, "defaultProps", {
  "data-id": "environment-selector",
  onEnvironmentChange: _underscore.default.noop,
  options: [],
  environment: "",
  newEnvironmentLabel: "+ New environment"
});
var _default = EnvironmentSelector;
exports.default = _default;
module.exports = exports["default"];